import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { Subscription } from 'rxjs';
import { ChatService } from 'src/app/services/chat.service';

@Component({
  selector: 'app-mdl-reportes-descargables',
  templateUrl: './mdl-reportes-descargables.page.html',
  styleUrls: ['./mdl-reportes-descargables.page.scss'],
})
export class MdlReportesDescargablesPage implements OnInit {

  @Input() idAdmin: any;
  canal: any;
  canales: any;
  canalInicial: any;
  classUser: any;
  reportes;
  mensajeSubscriptionReportes: Subscription;
  constructor(private modal: ModalController,
    private chat: ChatService,
    private storage: Storage
  ) {
      this.canales = [];
      this.reportes=[];
    }

  ngOnInit() {

    this.getCanal();

  }

  async getCanal() {
    this.canal = await this.storage.get('canal').then();
    this.canales = await this.storage.get('canales').then();
      // console.log(this.canales, 'canales ');
      this.canalInicial = this.canales.find(canal => canal.canale.idAdmin_sec == this.canal.idAdmin_sec);
      this.idAdmin = this.canalInicial.canale.idAdmin_sec;
      this.classUser = this.canalInicial;
    // console.log(this.canal.url_back, 'url de back desde storage');
    this.getReportesDescargados();
    this.getSocket();
  }

  getSocket(){
    this.mensajeSubscriptionReportes =this.chat
    .getAlertaCampana()
    .subscribe((msg) => {
      this.getReportesDescargados();
    });
  }

  getReportesDescargados() {
    this.chat.consultaReportesDisponibles(this.idAdmin, this.classUser.canale.url_back).subscribe((res: any)=>{
      //console.log(res);
      const {status, descargables} = res;
      this.reportes = descargables;
      console.log('reportes: ', this.reportes);
    });
  }

  close() {
    this.modal.dismiss();
  }

  descargarArchivo(url) {
    // console.log(url);
    window.location.href = url;
  }

}
